import { InjectionToken } from '@angular/core';

export const REQUEST = new InjectionToken<any>('MARKETPLACE_REQUEST');
export const RESPONSE = new InjectionToken<any>('MARKETPLACE_RESPONSE');
